import {definePreset} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import {variablesPreset} from './presets/variables.preset';
import {datePickerPreset} from './presets/date-picker.preset';
import {inputTextPreset} from './presets/input-text.preset';
import {panelPreset} from './presets/panel.preset';
import {breadcrumbPreset} from './presets/breadcrumb.preset';
import {buttonPreset} from './presets/button.preset';
import {dataTablePreset} from './presets/table.preset';
import {paginatorPreset} from './presets/paginator.preset';
const OpcoepPreset = definePreset(Aura, {
  primitive: {
    ...variablesPreset,
  },
  components: {
    panel: panelPreset,
    inputtext: inputTextPreset,
    datepicker: datePickerPreset,
    breadcrumb: breadcrumbPreset,
    button: buttonPreset,
    paginator: paginatorPreset,
    datatable: dataTablePreset,
  }
});

export default OpcoepPreset;
